const KEY = "progsity:playground:stdinExpanded";

/** Collapsed by default; persisted when user toggles. */
export function loadStdinExpanded(): boolean {
  if (typeof window === "undefined") return false;
  try {
    const v = localStorage.getItem(KEY);
    if (v === null) return false;
    return v === "true";
  } catch {
    return false;
  }
}

export function saveStdinExpanded(value: boolean): void {
  try {
    localStorage.setItem(KEY, value ? "true" : "false");
  } catch {
    /* ignore */
  }
}
